import React from 'react';
import { Redirect, Route, HashRouter as Router, Switch } from 'react-router-dom';
import history from "../history";
import BelgeGrubuVeTuru from './BelgeGrubuVeTuru';
import BasvuruAnaOzet from './BasvuruAnaOzet';
import HarcEkleForm from './HarcEkleForm';
import MapComponent from './MapComponent';
import ResmiRuhsatRapor from './ResmiRuhsatRapor';
import getParametreDeger from '../services/getParametreDeger';
import DenetimSonuclariForm from './DenetimSonuclariForm';
import HarcKriterleriForm from './HarcKriterleriForm';
import YibfEslesmeTalepForm from './YibfEslesmeTalepForm';
import RuhsatSoruCevapForm from './RuhsatSoruCevapForm';
import YibfEslesmemeSebebiForm from './YibfEslesmemeSebebiForm';
import MuellifSecimForm from './MuellifSecimForm';
import AltSurecBasvuruRapor from './AltSurecBasvuruRapor';
import KullaniciEkleForm from './KullaniciEkleForm';
import YibfExcelUploadForm from './YibfExcelUploadForm'
import RaportorSecimForm from './RaportorSecimForm';
import BasvuruIsimDegisiklikForm from './BasvuruIsimDegisiklikForm';
import CreateBasvuruWithYibfNoForm from './CreateBasvuruWithYibfNoForm';
import CreateIskanBasvuruWithAdaParselForm from './CreateIskanBasvuruWithAdaParselForm';
import RaportorAtaForm from './RaportorAtaForm';
import ImzacilariListeleForm from './ImzacilariListeleForm';
import BasvuruWorkflow from './BasvuruWorkflow';
import BasvuruIadeEtForm from './BasvuruIadeEtForm';
import ParentBasvuruRuhsatTipiForm from './ParentBasvuruRuhsatTipiForm';
import BasvuruEventSilForm from './BasvuruEventSilForm';
import AsamaPerformansRapor from './AsamaPerformansRapor';
import TumBelgelerveImzalarForm from './TumBelgelerveImzalarForm';
import CreateBasvuruForm from './CreateBasvuruForm';
import SorumluSecimForm from './SorumluSecimForm';
import muellifGuncelleForm from './MuellifGuncelleForm';
import IliskiliBasvuruGecmisiForm from './IliskiliBasvuruGecmisiForm';
import BasvuruSorumluKullaniciForm from './BasvuruSorumluKullaniciForm';
import EmlakBeyanForm from './EmlakBeyanForm';
import BasvuruOzellikByMultiRowTForm from './BasvuruOzellikByMultiRowTForm';
import TumBasvuruAnaOzet from './TumBasvuruAnaOzet';

import queryString from 'query-string';
import EbBasvuruOzellikForm from './EbBasvuruOzellikForm';
import ImzaciSecimForm from './ImzaciSecimForm';

const parsed = queryString.parse(history.location.search);
sessionStorage.setItem("userToken", parsed.sessionid);


const MainRouter = () => {
    getParametreDeger('EBELGE.ORTAK.COMPANY_NAME').then(res => { document.title = res.data.result + " E-Belge" });

    return <Router history={history}>
        <Switch>
            <Route
                exact
                path="/"
                render={() => <Redirect to="/kullaniciEkleForm" />}
            />
            <Route path="/belgeGrubuVeTuru" component={BelgeGrubuVeTuru} />
            <Route path="/basvuruAnaOzet" component={BasvuruAnaOzet} />
            <Route path="/harcEkleForm" component={HarcEkleForm} />
            <Route path="/resmiRuhsatRapor" component={ResmiRuhsatRapor} />
            <Route path="/denetimSonuclariForm" component={DenetimSonuclariForm} />
            <Route path="/harcKriterleriForm" component={HarcKriterleriForm} />
            <Route path="/yibfEslesmeTalepForm" component={YibfEslesmeTalepForm} />
            <Route path="/ruhsatSoruCevapForm" component={RuhsatSoruCevapForm} />
            <Route path="/yibfEslesmemeSebebiForm" component={YibfEslesmemeSebebiForm} />
            <Route path="/muellifSecimForm" component={MuellifSecimForm} />
            <Route path="/altSurecBasvuruRapor" component={AltSurecBasvuruRapor} />
            <Route path="/kullaniciEkleForm" component={KullaniciEkleForm} />
            <Route path="/yibfExcelUpload" component={YibfExcelUploadForm} />
            <Route path="/raportorSecimForm" component={RaportorSecimForm} />
            <Route path="/basvuruIsimDegisiklikForm" component={BasvuruIsimDegisiklikForm} />
            <Route path="/createBasvuruWithYibfNo" component={CreateBasvuruWithYibfNoForm} />
            <Route path="/createIskanBasvuruWithAdaParsel" component={CreateIskanBasvuruWithAdaParselForm} />
            <Route path="/raportorAtaForm" component={RaportorAtaForm} />
            <Route path="/imzacilariListeleForm" component={ImzacilariListeleForm} />
            <Route path="/basvuruWorkflow" component={BasvuruWorkflow} />
            <Route path="/basvuruIadeEtForm" component={BasvuruIadeEtForm} />
            <Route path="/parentBasvuruRuhsatTipiForm" component={ParentBasvuruRuhsatTipiForm} />
            <Route path="/basvuruEventSilForm" component={BasvuruEventSilForm} />
            <Route path="/asamaPerformansRapor" component={AsamaPerformansRapor} />
            <Route path="/tumBelgelerveImzalarForm" component={TumBelgelerveImzalarForm} />
            <Route path="/createBasvuruForm" component={CreateBasvuruForm} />
            <Route path="/sorumluSecimForm" component={SorumluSecimForm} />
            <Route path="/muellifGuncelleForm" component={muellifGuncelleForm}/>
            <Route path="/iliskiliBasvuruGecmisiForm" component={IliskiliBasvuruGecmisiForm}/>
            <Route path="/basvuruSorumluKullaniciForm" component={BasvuruSorumluKullaniciForm} />
            <Route path="/ebBasvuruOzellikForm" component={EbBasvuruOzellikForm} />
            <Route path="/emlakBeyanForm" component={EmlakBeyanForm} />
            <Route path="/BasvuruOzellikByMultiRowTForm" component={BasvuruOzellikByMultiRowTForm} />
            <Route path="/tumBasvuruAnaOzet" component={TumBasvuruAnaOzet} />
            <Route path="/ImzaciSecimForm" component={ImzaciSecimForm} />
            <Route path="/map" component={MapComponent} />
        </Switch>
    </Router>
};

export default MainRouter;
